// import { UUID } from "crypto";
import { useDispatch, useSelector } from "react-redux";
import { useDialogs } from "@toolpad/core/useDialogs";

import { RootState } from "@store/store";
import { setApplicationSelected } from "@store/slices/componentsSlice";
import { useLoadApplicationSelected } from "@hooks/useLoadApplicationSelected";
import { Notificacion } from "@components/DialogosSegmentos/Notificacion";
// Deshabilitado temporalmente junto con la asignación de owner por etapa (ver updateStatusApp).
// import { AsignarOwnerEtapa } from "@components/DialogosSegmentos/AsignarOwnerEtapa";
import {
    usePostStatusApplicationMutation,
    // usePutApplicationsMutation,
} from "@services/api/applications";
// import { AssignableOwner, useAssignableOwners } from "@hooks/useAssignableOwners";
import { ApplicationMarketplaceResume, ApplicationResume } from "@interfaces/application";

type AnyApplicationResume = ApplicationResume | ApplicationMarketplaceResume;

export function useChangeStatusApp() {
    const dialogs = useDialogs();
    const dispatch = useDispatch();

    const userSession = useSelector((state: RootState) => state.session.user);
    const applicationSelected = useSelector((state: RootState) => state.components.applicationSelected);

    const { loadApplicationSelected } = useLoadApplicationSelected();
    const [triggerPostStatusApplication] = usePostStatusApplicationMutation();
    // const [triggerPutApplication] = usePutApplicationsMutation();
    // const { loadAssignableOwners } = useAssignableOwners();

    const userFullName =
        userSession.name?.concat(" ", userSession.last_name ?? "", " ", userSession.last_name_2 ?? "").trim() ?? "";

    // Deshabilitado temporalmente: se pregunta por owner en cada cambio de etapa (ver updateStatusApp).
    // const setApplicationOwner = async (app: AnyApplicationResume, ownerId: UUID | null): Promise<void> => {
    //     await triggerPutApplication({
    //         applicationId: app.id,
    //         body: {
    //             user_bpm_id: ownerId,
    //             user_id_modified: userSession.id,
    //             user_name: userFullName,
    //         },
    //     }).unwrap();
    // };

    // const withOwner = (app: AnyApplicationResume, owner: AssignableOwner | null): AnyApplicationResume => ({
    //     ...app,
    //     user_bpm_id: owner?.id ?? null,
    //     user_bpm: owner
    //         ? { id: owner.id, name: owner.name, last_name: owner.last_name, last_name_2: owner.last_name_2 }
    //         : undefined,
    // });

    // const clearStageOwner = async (app: AnyApplicationResume): Promise<AnyApplicationResume> => {
    //     try {
    //         await setApplicationOwner(app, null);
    //     } catch (error) {
    //         console.error(`No se pudo limpiar el owner de la solicitud: ${error}`);
    //     }
    //     return withOwner(app, null);
    // };

    // /** Se dispara una vez que un cambio de estatus mueve la solicitud a una nueva etapa (`stage`). */
    // const resolveStageOwner = async (app: AnyApplicationResume): Promise<AnyApplicationResume> => {
    //     const wantsOwner = await dialogs.open(Notificacion, {
    //         type: "CONFIRM",
    //         text: `¿Desea asignar un owner para la siguiente etapa (${app.stage.name})?`,
    //         okText: "Sí",
    //         noText: "No",
    //     });

    //     if (wantsOwner !== true) return clearStageOwner(app);

    //     const availableOwners = await loadAssignableOwners({
    //         companyId: app.company_id,
    //         stageId: app.stage.id,
    //     }).catch(() => []);

    //     if (availableOwners.length === 0) {
    //         await dialogs.open(Notificacion, {
    //             type: "INFO",
    //             text: "Esta etapa no tiene encargados configurados. Ve a Administración > Encargados por Etapa para asignarlos.",
    //         });
    //         return clearStageOwner(app);
    //     }

    //     const selectedOwner = await dialogs.open(AsignarOwnerEtapa, {
    //         stageName: app.stage.name,
    //         options: availableOwners,
    //     });

    //     if (!selectedOwner) return app;

    //     try {
    //         await setApplicationOwner(app, selectedOwner.id);
    //     } catch (error) {
    //         console.error(`No se pudo asignar el owner a la solicitud: ${error}`);
    //         await dialogs.open(Notificacion, {
    //             type: "WARNING",
    //             text: "No se pudo asignar el owner a la solicitud.",
    //         });
    //         return app;
    //     }

    //     return withOwner(app, selectedOwner);
    // };

    const updateStatusApp = async (
        status: string,
        disableSequenceCheck: boolean | undefined = undefined,
        updateStore: boolean = true,
        sendNotification: boolean | undefined = undefined,
    ): Promise<AnyApplicationResume | void> => {
        try {
            // const previousStageId = applicationSelected.stage?.id;

            await triggerPostStatusApplication({
                applicationId: applicationSelected.id,
                userName: userFullName,
                statusCode: status,
                disableSequenceCheck: disableSequenceCheck,
                sendNotification: sendNotification,
            }).unwrap();

            // El régimen fiscal se toma del caché; solo el resumen se vuelve a consultar
            const updatedApp = await loadApplicationSelected({
                companyId: Number(applicationSelected.id_application_company),
                companySource: applicationSelected.company_source ?? "",
                updateStore: false,
            });

            if (updatedApp) {
                let finalApp: AnyApplicationResume = updatedApp;

                // Deshabilitado temporalmente: se pregunta por owner en cada cambio de etapa.
                // const stageChanged =
                //     previousStageId != null && finalApp.stage?.id != null && finalApp.stage.id !== previousStageId;

                // if (stageChanged) {
                //     finalApp = await resolveStageOwner(finalApp);
                // }

                if (updateStore == true) {
                    dispatch(setApplicationSelected(finalApp));
                } else if (updateStore == false) {
                    return finalApp;
                }
            }
        } catch (error) {
            dialogs.open(Notificacion, {
                type: "WARNING",
                text: "Ocurrio un error al cambiar el estado de la solicitud",
            });

            throw new Error("Ocurrio un error al cambiar el estado de la solicitud");

            return undefined;
        }

        // triggerPostStatusApplication({
        //     applicationId: applicationSelected.id,
        //     userName:
        //         userSession.name?.concat(" ", userSession.last_name ?? "", " ", userSession.last_name_2 ?? "").trim() ??
        //         "",
        //     statusCode: status,
        //     disableSequenceCheck: disableSequenceCheck,
        // })
        //     .then((_) => {
        //         triggerGetAppInfo({
        //             companyId: Number(applicationSelected.id_application_company),
        //             params: new URLSearchParams([
        //                 ["company_source", applicationSelected.company_source?.toUpperCase() as string],
        //             ]).toString(),
        //         }).then((result) => {
        //             triggerGetTaxSystemInfo(applicationSelected.tax_system.id).then((taxSystemResult) => {
        //                 const updatedApp = result.data;
        //                 if (updatedApp)
        //                     dispatch(
        //                         setApplicationSelected({
        //                             ...updatedApp,
        //                             tax_system: {
        //                                 ...updatedApp.tax_system,
        //                                 config_extra: omit(taxSystemResult.data?.config_extra, ["bpm_lateral_options"]),
        //                             },
        //                         }),
        //                     );
        //             });
        //         });
        //     })
        //     .catch((error) => {
        //         dialogs.open(Notificacion, {
        //             type: "WARNING",
        //             text: "Ocurrio un error al cambiar el estado de la solicitud",
        //         });
        //     });
    };

    return { updateStatusApp };
}
